var AMapMap = function () {

    var map = undefined;
    var markerClusterer = undefined; // 聚合工具

    var loaded = false; // 是否已经加载
    var drawingManager = false; // 画图工具
    var circleArray = [];
    var polygonArray = [];
    var polyLineArray = [];
    var markerArray = [];
    var clustererArray = [];
    var labelArray = [];

    var drawCallBack = undefined;

    var EarthRadiusKm = 6378.137; // WGS-84

    function normalizeColor(color, defaultColor = "#CD3700") {
        if (!color) return defaultColor;
        if (!isNaN(color)) return "#" + color.toString(16);
        return color.length === 7 ? color : defaultColor;
    }

    function removeElementFromArr(elements, id) {
        if (!elements) return;

        if (id) {
            const index = elements.findIndex(element => element.id === id);
            if (index !== -1) {
                map.remove(elements[index].overlay);
                elements.splice(index, 1);
            }
        } else {
            elements.forEach(element => map.remove(element.overlay));
            elements.length = 0;
        }
    }

    this.loadScript = function (url) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
    }

    this.showCluster = function () {
        if (map) {
            // 实现聚合功能
        }
    }

    this.removeClustererById = function (id) {
        console.log("removeClustererById" + id)
        if (id) {
            for (var i = 0; i < clustererArray.length; i++) {
                if (clustererArray[i].id == id) {
                    if (markerClusterer) {
                        markerClusterer.removeMarker(clustererArray[i].overlay);
                    }
                    clustererArray.splice(i, 1);
                    break;
                }
            }
        }
    },

        this.addMarkerToCluster = function (id, name, lng, lat, iconUrl, callback) {
            if (!loaded) return;
            if (lng == undefined || lat == undefined) return false;
            if (id == undefined || id == "") id = "marker0";
            if (name == undefined) name = "marker";
            var myIcon = undefined;
            if (iconUrl) {
                myIcon = new AMap.Icon({
                    size: new AMap.Size(22, 32),
                    image: require("@/" + iconUrl),
                    imageSize: new AMap.Size(22, 32),
                    imageOffset: new AMap.Pixel(-10, -25)
                });
            }

            var marker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat),
                icon: myIcon,
                title: name
            });

            if (callback) marker.on("click", callback);

            var label = new AMap.Text({
                position: new AMap.LngLat(lng, lat),
                text: name,
                offset: new AMap.Pixel(-30, 35),
                style: {
                    color: "#444444",
                    fontSize: "13px",
                    border: "1px solid #DDDDDD",
                    backgroundColor: "#FFFFFF",
                    padding: "3px"
                }
            });

            clustererArray.push({ id: id, overlay: marker });

            if (!markerClusterer) {
                markerClusterer = new AMap.MarkerClusterer(map, [marker], {
                    gridSize: 80,
                    maxZoom: 15
                });
            } else {
                markerClusterer.addMarker(marker);
            }
        }

    /*
      opts = {
        center: [116.404, 39.915],中心点经纬度
        zoom: 12,缩放级别
      }
      */
    this.initMap = function (mapId, opts) {
        if (loaded || map !== undefined) {
            return Promise.resolve(map);
        }

        try {
            // 参数验证
            if (!mapId) {
                throw new Error('Map ID is required');
            }

            opts = opts || { coordsType: 'gcj02' };

            // 初始化地图
            map = new AMap.Map(mapId, {
                zoom: opts.zoom || 14,
                center: new AMap.LngLat(opts.center[0], opts.center[1]) || new AMap.LngLat(116.404, 39.915),
                zooms: [3, 18],
                resizeEnable: true
            });

            // 添加地图控件
            map.addControl(new AMap.ToolBar());

            drawingManager = new AMap.MouseTool(map);
            drawingManager.on("draw", function (event) {
                //event.obj 为绘制出来的覆盖物对象
                console.log(event.obj);

                switch (event.obj.className) {
                    case 'AMap.Marker'://点
                        // console.log(event.obj.getPosition());
                        if (drawCallBack)
                            drawCallBack(event.obj.getPosition().lng, event.obj.getPosition().lat);

                        break;
                    case 'Overlay.Polyline'://折线 
                        var path = event.obj.getPath();

                        var lonlats = "";
                        for (var i = 0; i < path.length; i++) {
                            if (lonlats != "") lonlats += ";";

                            lonlats += path[i].lng + "," + path[i].lat;
                        }
                        if (drawCallBack) drawCallBack(lonlats);

                        break;
                    case 'Overlay.Polygon'://多边形

                        var path = event.obj.getPath();

                        var lonlats = "";
                        for (var i = 0; i < path.length; i++) {
                            if (lonlats != "") lonlats += ";";
                            lonlats += path[i].getLng() + "," + path[i].getLat();
                        }
                        if (drawCallBack) drawCallBack(lonlats);
                        // polygonArray.push(event.obj);
                        break;
                    case 'Overlay.Rectangle'://矩形

                        var bounds = event.obj.getBounds();
                        var sw = bounds.getSouthWest();
                        var ne = bounds.getNorthEast();

                        if (drawCallBack) drawCallBack(sw.getLng(), sw.getLat(), ne.getLng(), ne.getLat());


                        // polygonArray.push(event.obj);
                        break;
                    case 'Overlay.Circle'://圆

                        var center = event.obj.getCenter();
                        var radius = event.obj.getRadius();

                        if (drawCallBack) drawCallBack(center.getLng(), center.getLat(), radius);
                        // circleArray.push(event.obj);
                        break;
                }
                console.log("覆盖物对象绘制完成");
            });
            //    map.addControl(new AMap.MouseTool());

            //   map.addControl(new AMap.Navigation());
            //   map.enableScrollWheelZoom(true);

            // 监听地图加载完成事件
            const completeHandler = () => {
                if (!loaded && opts.completed) {
                    loaded = true;
                    opts.completed();
                }
            };

            map.on('complete', completeHandler);

        } catch (error) {
            console.error('Failed to initialize AMap:', error);
            throw error;
        }

    };

    this.clearAll = function () {
        map.clearMap();
        // 清空内部数组
        markerArray.length = 0;
        polyLineArray.length = 0;
        polygonArray.length = 0;
        circleArray.length = 0;
        clustererArray.length = 0;
        labelArray.length = 0;
        // 重置聚合器
        if (markerClusterer) {
            markerClusterer.clearMarkers();
        }
    };

    this.setCenter = function (lng, lat) {
        console.log("setCenter", lng, lat);
        map.setCenter(new AMap.LngLat(lng, lat));
    };

    // 添加点
    this.addMarker = function (id, name, lng, lat, iconUrl, callback, iconWidth, iconHeight) {
        if (!loaded) return;
        if (lng == undefined || lat == undefined) return false;
        if (id == undefined || id == "") id = "marker0";
        if (name == undefined) name = "marker";
        var myIcon = undefined;
        if (iconUrl) {
            if (iconWidth == undefined) {
                iconWidth = 22
            }
            if (iconHeight == undefined) {
                iconHeight = 32
            }
            myIcon = new AMap.Icon({
                size: new AMap.Size(iconWidth * 2, iconHeight),
                image: require("@/" + iconUrl),
                imageSize: new AMap.Size(iconWidth, iconHeight),
                imageOffset: new AMap.Pixel(0, 0)
            });

        }

        var marker = new AMap.Marker({
            position: new AMap.LngLat(lng, lat),
            icon: myIcon,
            title: name
        });

        if (callback) marker.on("click", callback);

        map.add(marker);
        markerArray.push({ id: id, overlay: marker });

        // 添加对应的label
        var label = new AMap.Text({
            position: new AMap.LngLat(lng, lat),
            text: name,
            offset: new AMap.Pixel(-30, 10),
            style: {
                color: "#444444",
                fontSize: "13px",
                border: "1px solid #DDDDDD",
                backgroundColor: "#FFFFFF",
                padding: "3px"
            }
        });

        map.add(label);
        labelArray.push({ id: id, overlay: label });
        return marker;
    };

    // 添加线
    this.addPolyline = function (id, name, coordinators, width, color, isArrow) {
        console.log("addPolyline1");

        if (!loaded) return;

        if (coordinators == undefined || coordinators == "") return false;
        if (id == undefined || id == "") id = "line0";
        if (name == undefined) name = "";
        if (width == undefined || width == "") width = 1;
        if (color == undefined || color == "") color = "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";

        isArrow = isArrow || false

        var path = [];
        for (var i = 0; i < coordinators.length; i++) {
            if (coordinators[i].lat != undefined && coordinators[i].lng) {
                path.push(new AMap.LngLat(coordinators[i].lng, coordinators[i].lat));
            }
        }

        var polyline = new AMap.Polyline({
            path: path,
            strokeColor: color,
            strokeWeight: width,
            strokeOpacity: 0.8,
            lineJoin: 'round',
            lineCap: 'round'
        });

        map.add(polyline);
        console.log("addPolyline2");
        map.setFitView([polyline]);
        polyLineArray.push({ id: id, overlay: polyline });
    };

    this.removeMarkerById = function (id) {
        if (!loaded) return;
        removeElementFromArr(markerArray, id);
        removeElementFromArr(labelArray, id);
    };

    this.clearMarkers = function (id) {
        if (!loaded) return;
        removeElementFromArr(markerArray);
        removeElementFromArr(labelArray);
    };

    this.removePolylineById = function (id) {
        if (!loaded) return;
        removeElementFromArr(polyLineArray, id);
    };

    this.removePolygonById = function (id) {
        if (!loaded) return;
        removeElementFromArr(polygonArray, id);
    };

    // 添加多边形
    this.addPolygon = function (
        id,
        name,
        coordanites,
        strokeWidth,
        strokeColor,
        fillColor
    ) {
        if (!loaded) return;
        if (coordanites == undefined || coordanites == "") return false;
        if (id == undefined || id == "") id = "region0";
        if (name == undefined) name = "";

        if (strokeWidth == undefined || strokeWidth == "") strokeWidth = 1;

        var path = [];
        for (var i = 0; i < coordanites.length; i++) {
            path.push(new AMap.LngLat(coordanites[i].lng, coordanites[i].lat));
        }

        if (strokeColor == undefined || strokeColor == "") strokeColor = "#CD3700";
        if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
        if (strokeColor.length != 7) strokeColor = "#CD3700";

        if (fillColor == undefined || fillColor == "") fillColor = "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        var polygon = new AMap.Polygon({
            path: path,
            strokeColor: strokeColor,
            strokeWeight: strokeWidth,
            strokeOpacity: 0.5,
            fillColor: fillColor,
            fillOpacity: 0.35
        });

        map.add(polygon);
        map.setFitView([polygon]);
        polygonArray.push({ id: id, overlay: polygon });
    };

    this.addCircle = function (
        id,
        lnglat,
        radius,
        strokeWidth,
        strokeColor,
        fillColor
    ) {
        if (!loaded) return;
        if (lnglat == undefined || radius == undefined) return false;
        if (id == undefined || id == "") id = "circle0";
        if (strokeWidth == undefined || strokeWidth == "") strokeWidth = 1;

        var center = new AMap.LngLat(lnglat.lng, lnglat.lat);
        strokeColor = strokeColor || "#CD3700";
        if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
        if (strokeColor.length != 7) strokeColor = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        var circle = new AMap.Circle({
            center: center,
            radius: parseFloat(radius),
            strokeColor: strokeColor,
            fillColor: fillColor,
            fillOpacity: 0.35,
            strokeWeight: strokeWidth,
            strokeOpacity: 0.8
        });

        map.add(circle);
        map.setFitView([circle]);
        circleArray.push({ id: id, overlay: circle });
    };

    this.cancelDraw = function () {
        map.clearMap();
        if (drawingManager) {
            drawingManager.close();
        }
    };

    this.drawPoint = function (callback) {
        if (!loaded) return;

        map.clearMap();

        drawCallBack = callback;

        drawingManager.marker();



        // drawingManager.on('markerComplete', function (marker) {
        //   drawingManager.close();
        //   var position = marker.getPosition();
        //   if (callback) callback(position.getLng(), position.getLat());
        // });
    };

    this.drawRectangle = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        map.clearMap();

        drawCallBack = callback;

        drawingManager.rectangle({
            strokeColor: color, //轮廓线颜色
            strokeOpacity: 0.8, //轮廓线透明度
            strokeWeight: width, //轮廓线宽度
            fillColor: fillColor, //多边形填充颜色
            fillOpacity: 0.35, //多边形填充透明度
            strokeStyle: 'solid', //线样式还支持 'dashed'
            //strokeDasharray: [30,10], //strokeDasharray 属性在 strokeStyle 是 dashed 时有效
        })



        // drawingManager.on('rectangleComplete', function (rectangle) {
        //     drawingManager.close();
        //     var bounds = rectangle.getBounds();
        //     var sw = bounds.getSouthWest();
        //     var ne = bounds.getNorthEast();

        //     if (callback) callback(sw.getLng(), sw.getLat(), ne.getLng(), ne.getLat());
        // });
    };

    this.drawPolygon = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        map.clearMap();

        drawCallBack = callback;

        drawingManager.polygon({
            strokeColor: color, //轮廓线颜色
            strokeOpacity: 0.8, //轮廓线透明度
            strokeWeight: width, //轮廓线宽度

            fillColor: fillColor, //多边形填充颜色
            fillOpacity: 0.35, //多边形填充透明度
            strokeStyle: "solid", //线样式还支持 'dashed'
            //strokeDasharray: [30,10], //strokeDasharray 属性在 strokeStyle 是 dashed 时有效
        })


    };

    this.drawLine = function (width, color, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#0609D8";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#0609D8";

        map.clearMap();

        drawCallBack = callback;
        drawingManager.polyline({
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: width,
            // 线样式还支持 'dashed'
            strokeStyle: "solid",
            // strokeStyle是dashed时有效
            // strokeDasharray: [10, 5],
        })

    };

    this.drawCircle = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        map.clearMap();

        drawCallBack = callback;
        drawingManager.circle({
            strokeColor: color, //轮廓线颜色
            strokeOpacity: 0.8, //轮廓线透明度
            strokeWeight: width, //轮廓线宽度  
            fillColor: fillColor, //多边形填充颜色
            fillOpacity: 0.35, //多边形填充透明度
            strokeStyle: 'solid', //线样式还支持 'dashed'
            //strokeDasharray: [30,10], //strokeDasharray 属性在 strokeStyle 是 dashed 时有效
        })


    };

    this.pointToLineDist = function (x1, y1, x2, y2, x0, y0) {
        var space = 0;
        var a, b, c;
        a = this.calcDistance(x1, y1, x2, y2); // 线段的长度
        b = this.calcDistance(x1, y1, x0, y0); // (x1,y1)到点的距离
        c = this.calcDistance(x2, y2, x0, y0); // (x2,y2)到点的距离
        if (c <= 0.000001 || b <= 0.000001) {
            space = 0;
            return space;
        }
        if (a <= 0.000001) {
            space = b;
            return space;
        }
        if (c * c >= a * a + b * b) {
            space = b;
            return space;
        }

        if (b * b >= a * a + c * c) {
            space = c;
            return space;
        }

        var p = (a + b + c) / 2; // 半周长
        var s = Math.sqrt(p * (p - a) * (p - b) * (p - c)); // 海伦公式求面积
        space = (2 * s) / a; // 返回点到线的距离（利用三角形面积公式求高）
        return space;
    };

    this.calcDistance = function (p1Lng, p1Lat, p2Lng, p2Lat) {
        var dLat1InRad = p1Lat * (Math.PI / 180);
        var dLong1InRad = p1Lng * (Math.PI / 180);
        var dLat2InRad = p2Lat * (Math.PI / 180);
        var dLong2InRad = p2Lng * (Math.PI / 180);
        var dLongitude = dLong2InRad - dLong1InRad;
        var dLatitude = dLat2InRad - dLat1InRad;
        var a = Math.pow(Math.sin(dLatitude / 2), 2) + Math.cos(dLat1InRad) * Math.cos(dLat2InRad) * Math.pow(Math.sin(dLongitude / 2), 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var dDistance = EarthRadiusKm * c;
        return dDistance * 1000;
    };

    // 定义一些常量
    var x_PI = (3.14159265358979324 * 3000.0) / 180.0;
    var PI = 3.1415926535897932384626;
    var a = 6378245.0;
    var ee = 0.00669342162296594323;

    /**
     * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
     * 即 百度 转 谷歌、高德
     * @param bd_lon
     * @param bd_lat
     * @returns {*[]}
     */
    function bd09togcj02(bd_lon, bd_lat) {
        var x_pi = (3.14159265358979324 * 3000.0) / 180.0;
        var x = bd_lon - 0.0065;
        var y = bd_lat - 0.006;
        var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
        var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
        var gg_lng = z * Math.cos(theta);
        var gg_lat = z * Math.sin(theta);
        return { lng: gg_lng, lat: gg_lat };
    }

    /**
     * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
     * 即谷歌、高德 转 百度
     * @param lng
     * @param lat
     * @returns {*[]}
     */
    function gcj02tobd09(lng, lat) {
        var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
        var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
        var bd_lng = z * Math.cos(theta) + 0.0065;
        var bd_lat = z * Math.sin(theta) + 0.006;
        return { lng: bd_lng, lat: bd_lat };
    }

    /**
     * WGS84转GCj02
     * @param lng
     * @param lat
     * @returns {*[]}
     */
    function wgs84togcj02(lng, lat) {
        if (out_of_china(lng, lat)) {
            return { lng: lng, lat: lat };
        } else {
            var dlat = transformlat(lng - 105.0, lat - 35.0);
            var dlng = transformlng(lng - 105.0, lat - 35.0);
            var radlat = (lat / 180.0) * PI;
            var magic = Math.sin(radlat);
            magic = 1 - ee * magic * magic;
            var sqrtmagic = Math.sqrt(magic);
            dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
            dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
            var mglat = lat + dlat;
            var mglng = lng + dlng;
            return { lng: mglng, lat: mglat };
        }
    }

    /**
     * GCJ02 转换为 WGS84
     * @param lng
     * @param lat
     * @returns {*[]}
     */
    function gcj02towgs84(lng, lat) {
        if (out_of_china(lng, lat)) {
            return { lng: lng, lat: lat };
        } else {
            var dlat = transformlat(lng - 105.0, lat - 35.0);
            var dlng = transformlng(lng - 105.0, lat - 35.0);
            var radlat = (lat / 180.0) * PI;
            var magic = Math.sin(radlat);
            magic = 1 - ee * magic * magic;
            var sqrtmagic = Math.sqrt(magic);
            dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
            dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
            var mglat = lat + dlat;
            var mglng = lng + dlng;
            return { lng: lng * 2 - mglng, lat: lat * 2 - mglat };
        }
    }

    function transformlat(lng, lat) {
        var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
        ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
        ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0;
        ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0;
        return ret;
    }

    function transformlng(lng, lat) {
        var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
        ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
        ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0;
        ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0;
        return ret;
    }

    /**
     * 判断是否在国内，不在国内则不做偏移
     * @param lng
     * @param lat
     * @returns {boolean}
     */
    function out_of_china(lng, lat) {
        return (lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271 || false);
    }
};

export { AMapMap };